// import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fromLang } from 'store/selectors';

const translationPropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.array,
]);

const T = ({ render, translation }) => render(translation);
T.propTypes = {
  text: translationPropType.isRequired,
  translation: translationPropType,
  render: PropTypes.func.isRequired,
};

const mapStateToProps = (state, { text }) => ({
  translation: fromLang.t(state, text),
});

export default connect(mapStateToProps)(T);



// WEBPACK FOOTER //
// ./src/containers/T.js